import React from 'react';
import { MIcon } from '../../../lib/micon';
import { LdSheet } from '../../../components/ui/LdSheet';

// Welle P1d: EINE Liste für „Eintragen“ — dieselben Einträge, Reihenfolge und Texte im
// Handy-Sheet und im PC-Menü. Jede Zeile öffnet das bestehende Sheet mit dem Kind vorbelegt.
export type SchnellAktion = 'notiz' | 'mitarbeit' | 'fehlzeit' | 'note' | 'gespraech';
export const EINTRAGEN: { key: SchnellAktion; label: string; icon: string; text: (vorname: string) => string }[] = [
  { key: 'notiz',     label: 'Notiz',     icon: 'sticky_note_2', text: v => `Etwas über ${v} festhalten` },
  { key: 'mitarbeit', label: 'Mitarbeit', icon: 'back_hand',     text: () => 'Beobachtung für diese Woche' },
  { key: 'fehlzeit',  label: 'Fehlzeit',  icon: 'event_busy',    text: () => 'Gefehlt, verspätet, Attest' },
  { key: 'note',      label: 'Note',      icon: 'star',          text: () => 'Klassenarbeit, Test, Referat' },
  { key: 'gespraech', label: 'Gespräch',  icon: 'forum',         text: v => `Mit Eltern oder mit ${v}` },
];

/** Handy: „Für {Vorname} eintragen“ — fünf große Zeilen, darunter „Lieber erzählen?“ */
export function EintragenSheet({ open, vorname, onClose, onWahl, onErzaehlen }: {
  open: boolean; vorname: string; onClose: () => void;
  onWahl: (a: SchnellAktion) => void;
  onErzaehlen: () => void;
}) {
  return (
    <LdSheet open={open} onClose={onClose} maxWidth={480} kopf={{ titel: `Für ${vorname} eintragen`, kontext: 'Was möchtest du festhalten?' }}>
      <div className="ld-es">
        <ul className="ld-es__liste">
          {EINTRAGEN.map(e => (
            <li key={e.key}>
              <button type="button" className="ld-es__zeile" onClick={() => onWahl(e.key)}>
                <span className="ld-es__icon" aria-hidden="true"><MIcon name={e.icon} size={22} /></span>
                <span className="ld-es__text"><b>{e.label}</b><span>{e.text(vorname)}</span></span>
                <MIcon name="chevron_right" size={20} className="ld-es__pfeil" />
              </button>
            </li>
          ))}
        </ul>
        <button type="button" className="ld-es__erzaehlen" onClick={onErzaehlen}>
          <span className="ld-es__mic" aria-hidden="true"><MIcon name="mic" size={20} /></span>
          <span><b>Lieber erzählen?</b><span>Sag einfach, was war. Die App ordnet es {vorname} zu, du bestätigst.</span></span>
        </button>
      </div>
    </LdSheet>
  );
}

/** Handy: feste Leiste über der App-Navigation — links Erzählen, rechts der passende Knopf */
export function AktionsLeiste({ vorname, rechts, onErzaehlen }: {
  vorname: string; rechts: { label: string; onClick: () => void }; onErzaehlen: () => void;
}) {
  return (
    <div className="ld-al" role="toolbar" aria-label={`Für ${vorname}`}>
      <button type="button" className="ld-al__erzaehlen" onClick={onErzaehlen}><MIcon name="mic" size={20} />Über {vorname} erzählen</button>
      <button type="button" className="ld-al__plus" onClick={rechts.onClick}><MIcon name="add" size={20} />{rechts.label}</button>
    </div>
  );
}
